import { useRestDataSource } from './useRestDataSource';

export function useShipmentDataSource({
  quickFilterText,
  selectedContentTypeFields,
}: {
  quickFilterText?: string;
  selectedContentTypeFields?: string[];
}) {
  const { dataSource } = useRestDataSource({
    quickFilterText,
    selectedContentTypeFields,
  });

  return { dataSource };
}
